<section fxLayout="column" fxLayoutAlign="start center" class="main-container">
  <app-banner *ngIf="passed" [text]="banner.RESULT_PASSED"></app-banner>
  <app-banner *ngIf="!passed" [text]="resultFailedMessage"></app-banner>
  <app-result-viewer *ngIf="!passedReview" class="result-comp"></app-result-viewer>
</section>
